import { servicesApi } from '../services';
import { HabilitationChoice } from './types';

const HABILITATION_PREFIX = 'habilitations';

export const habilitationApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({
    chooseHabilitation: build.mutation<void, ChooseHabilitationMutationArgs, any>({
      query: ({ token, choice, commentaire }) => ({
        url: `${HABILITATION_PREFIX}/${token}?choice=${choice}`,
        method: 'DELETE',
        body: commentaire || undefined,
      }),
    }),
    isTokenActive: build.query<void, IsTokenActiveQueryArgs, any>({
      query: ({ token }) => `${HABILITATION_PREFIX}/${token}`,
    }),
  }),
});

interface ChooseHabilitationMutationArgs {
  token: string;
  choice: HabilitationChoice;
}

interface IsTokenActiveQueryArgs {
  token: string;
}

export const {
  useChooseHabilitationMutation,
  useIsTokenActiveQuery,
} = habilitationApi;
